import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const LinkArrow = forwardRef(({ className }, ref) => (
  <svg ref={ref} width="43" height="43" viewBox="0 0 43 43" className={className}>
    <circle cx="21.5" cy="21.5" r="21.5" fill="var(--color-black)" />
    <path d="M18 7.5 l10 14 l-10 14" stroke="var(--color-greyDE)" strokeWidth="2" fill="none" />
  </svg>
));

LinkArrow.defaultProps = { className: null };
LinkArrow.propTypes = { className: PropTypes.string };

export default LinkArrow;
